export type EmbedType = 'youtube' | 'vimeo' | 'maps' | 'figma' | 'loom' | 'generic';

export interface ParsedEmbed {
  embedUrl: string;
  embedType: EmbedType;
}

export function parseEmbedUrl(rawUrl: string): ParsedEmbed {
  const url = (rawUrl ?? '').trim();
  if (!url) return { embedUrl: '', embedType: 'generic' };

  // YouTube: matched by 11-char video ID only. Non-video URLs (channels, shorts,
  // playlists) intentionally fall through to 'generic' — the embed iframe needs a
  // real video ID, so type classification stays driven by a usable embed URL.
  const yt = url.match(
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/
  );
  if (yt) return { embedUrl: `https://www.youtube.com/embed/${yt[1]}`, embedType: 'youtube' };

  const vimeo = url.match(/vimeo\.com\/(\d+)/);
  if (vimeo) return { embedUrl: `https://player.vimeo.com/video/${vimeo[1]}`, embedType: 'vimeo' };

  if (url.includes('google.com/maps') || url.includes('goo.gl/maps')) {
    const embedUrl = url.includes('/embed') ? url : url.replace('/maps/', '/maps/embed?');
    return { embedUrl, embedType: 'maps' };
  }

  if (url.includes('figma.com')) {
    return {
      embedUrl: `https://www.figma.com/embed?embed_host=gam&url=${encodeURIComponent(url)}`,
      embedType: 'figma',
    };
  }

  const loom = url.match(/loom\.com\/share\/([a-zA-Z0-9]+)/);
  if (loom) return { embedUrl: `https://www.loom.com/embed/${loom[1]}`, embedType: 'loom' };

  return { embedUrl: url, embedType: 'generic' };
}
